import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';
import { BRAND } from '../config/brand.js';

export default function Logo({ size = 64, to = '/' }) {
  return (
    <Link to={to} className="logo" aria-label={`${BRAND} home`}>
      <img src={logo} alt={BRAND} width={size} height={size} style={{ height: size, width: size }} />
    </Link>
  );
}
